import _ from 'lodash';

const catalogServiceFactory = (
  $log,
  $q,
  Dispatcher,
  StentleBackendService,
  StorageService,
  StoreStates,
  StoreService,
  endPoints,
  NewBackendService
) => {
  'ngInject';

  const parsers = {
    // prepare data generated in app to be sent to the backend
    app: {
      productParser: (product) => [
        { op: 'replace', path: '/name', value: product.name },
        { op: 'replace', path: '/description', value: product.description },
        { op: 'replace', path: '/categoryId', value: product.subCategory.id },
        { op: 'replace', path: '/code', value: product.code },
        {
          op: 'replace',
          path: '/sellingPrice',
          value: parseFloat(product.price),
        },
        { op: 'replace', path: '/availability', value: 999999999 },
      ],
      variantParser: (variant) => [
        { op: 'replace', path: '/name', value: variant.name },
        { op: 'replace', path: '/availability', value: variant.availability }
      ],
      createProductParser: (product, menuIds, variant) => ({
        name: variant && variant.name ? variant.name : product.name,
        description: product.description,
        code: product.code,
        categoryId: product.subCategory.id,
        sellingPrice: parseFloat(product.price),
        preAuthorized: true,
        availability: variant && variant.availability ? variant.availability : 999999999,
        published: true,
        menuIds: menuIds,
        thumb: product.img,
      }),
      createCategoryParser: (categoryName) => ({
        type: 'child',
        active: true,
        italianName: categoryName,
        englishName: categoryName,
      }),
      productIdsCollectionParser: (productIds) => [
        { op: 'replace', path: '/products/-', value: productIds },
      ],
      productIdsRemoveCollectionParser: (productIds) => [
        { op: 'remove', path: '/products/-', value: productIds },
      ],
      /* productParser: product => ({
        names: {
          it: {
            value: product.name,
            locale: 'it'
          }
        },
        descriptions: {
          it: {
            value: product.description,
            locale: 'it'
          }
        },
        macroCategory: product.category ? {
          key: product.category.key
        } : undefined,
        microCategory: product.subCategory ? {
          key: product.subCategory.key
        } : undefined,
        prices: {
          sellingPrice: parseFloat(product.price).toFixed(2)
        }
      }),*/
      collectionParser: (collection) => ({
        name: collection.name,
        description: collection.description,
        enabled: true,
      }),
      enableDisableCollectionParser: (id, enable, name, description) => [
        { op: 'replace', path: '/name', value: name },
        { op: 'replace', path: '/description', value: description },
      ],
    },
    // prepare data received from the backend to be displayed in app
    be: {
      categoryParser: (category) => ({
        id: category.id,
        key: category.key,
        name: category.name,
      }),
      completeCategoryParser: (category) => ({
        id: category.id,
        key: category.key,
        name: category.name,
        subCategories: category.children,
      }),
      productParser: (product) => ({
        id: product.id,
        name: product.name,
        description: product.description,
        code: product.code,
        available: product.published,
        price: parseFloat(product.sellingPrice).toFixed(2),
        category: product.macroCategory
          ? parsers.be.categoryParser(product.macroCategory)
          : undefined,
        subCategory: product.microCategory
          ? parsers.be.categoryParser(product.microCategory)
          : undefined,
        availability: product.availability,
        hasCoverPhoto: product.hasCoverPhoto,
      }),
      collectionParser: (collection) => ({
        id: collection.id,
        name: collection.name,
        description: collection.description,
        products: _.map(
          _.filter(
            collection.products,
            (product) => product.status === 'AUTHORIZED'
          ),
          (product) => parsers.be.productParser(product)
        ),
        active: Boolean(collection.enable),
      }),
      /*collectionParser: collection => ({
        id: collection.id,
        name: 'merchantStoreMenu' in collection ? collection.merchantStoreMenu.name : collection.names.it,
        description: 'merchantStoreMenu' in collection ? collection.merchantStoreMenu.description : collection.descriptions.it,
        products: _.map(_.filter(collection.products, product => product.status === 'AUTHORIZED'), product => product.id),
        active: 'merchantStoreMenu' in collection ? Boolean(collection.merchantStoreMenu.status) : false
      })*/
    },
  };
  const executeSubsequentially = funcs =>
      funcs.reduce((promise, func) =>
          promise.then(result => func().then(Array.prototype.concat.bind(result))), Promise.resolve([]));

  const setProductAvailability = (productId, availability) =>
    $q((resolve, reject) => {
      var parsedProduct = [
        { op: 'replace', path: '/published', value: availability },
      ];
      var merchantProfile = JSON.parse(
        StorageService.getLocalStorage('userContext')
      );
      NewBackendService.invokeWebApiPatch(
        `${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/${
          StoreService.getSelectedStore().id
        }/products/${productId}`,
        parsedProduct
      ).then(
        (savedProduct) => resolve(parsers.be.productParser(savedProduct)),
        reject
      );
    });
  /* const setProductAvailability = (productId, availability) => $q((resolve, reject) => {
    StentleBackendService.get(`products/${productId}/availabilities`).then(productAvailabilitiesResponse => {
      if (productAvailabilitiesResponse.status === 204) {
        StentleBackendService.get('warehouses').then(getWarehousesResponse => {
          if (getWarehousesResponse.status === 204) {
            reject({
              errorCode: 'NO_WAREHOUSES',
              errorMessage: 'No warehouse found'
            });
          } else {
            const warehouseId = getWarehousesResponse.data.data.items[0].id;
            StentleBackendService.post(`products/${productId}/availabilities`, {
              warehouseId,
              availability
            }).then(savedProduct => resolve(parsers.be.productParser(savedProduct)), reject);
          }
        });
      } else if (productAvailabilitiesResponse.data.data.items.length > 0) {
        const availabilityId = productAvailabilitiesResponse.data.data.items[0].id;
        StentleBackendService.put(`products/${productId}/availabilities/${availabilityId}`, {
          availability
        }).then(savedProduct => resolve(parsers.be.productParser(savedProduct)), reject);
      }
    }, reject);
  });*/

  const service = {
    // CATEGORIES
    getCategories: (complete) =>
      $q((resolve, reject) => {
        NewBackendService.invokeWebApiGet(
          `${endPoints.ecommerceUrl}/products/categories`
        ).then((getCategoriesResponse) => {
          const categories = getCategoriesResponse.data;
          if (complete)
            resolve(_.map(categories, parsers.be.completeCategoryParser));
          else resolve(_.map(categories, parsers.be.categoryParser));
        }, reject);
      }),
    getSubCategories: (parentKey) =>
      $q((resolve, reject) => {
        NewBackendService.invokeWebApiGet(
          `${endPoints.ecommerceUrl}/products/categories`
        ).then((getCategoriesResponse) => {
          const categories = getCategoriesResponse.data;
          var subCategories = [];
          _.forEach(categories, (category) => {
            if (category.key === parentKey) {
              subCategories = subCategories.concat(category.children);
            }
          });
          resolve(_.map(subCategories, parsers.be.categoryParser));
        });
      }),
    createCategory: (categoryName, parentId) =>
      $q((resolve, reject) => {
        // var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
        const parsedCategory = parsers.app.createCategoryParser(categoryName);
        NewBackendService.invokeWebApiPost(
          `${endPoints.ecommerceUrl}/products/categories/${parentId}`,
          parsedCategory
        ).then(() => {
          resolve();
        }, reject);
      }),
    deleteCategory: (categoryId) =>
      NewBackendService.invokeWebApiDelete(
        `${endPoints.ecommerceUrl}/products/categories/${categoryId}`
      ),
    // PRODUCTS
    getProducts: (page, size) =>
      $q((resolve, reject) => {
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        var storeSelected = StoreService.getSelectedStore();
        var id = storeSelected
          ? storeSelected.id
          : StorageService.getLocalStorageObject('storeList')[0].id;
        NewBackendService.invokeWebApiGet(
          `${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/${id}/products`,
          { page: page, size: size }
        ).then((getProductsResponse) => {
          if (getProductsResponse.status === 204) {
            resolve([]);
          } else {
            var products = [];
            if (getProductsResponse.data._embedded) {
              products = getProductsResponse.data._embedded.products;
            }
            resolve({
              products: _.map(products, parsers.be.productParser),
              pagination: getProductsResponse.data.page,
            });
          }
        }, reject);
      }),
    getImageProduct: (idProduct) =>
      $q((resolve, reject) => {
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        var storeSelected = StoreService.getSelectedStore();
        var id = storeSelected
          ? storeSelected.id
          : StorageService.getLocalStorageObject('storeList')[0].id;
        NewBackendService.invokeWebApiGet(
          `${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/${id}/products/${idProduct}`
        ).then((res) => {
          if (res.status === 204) {
            resolve({});
          } else {
            resolve(res.data.thumb);
          }
        }, reject);
      }),
    getAllProducts: () =>
      $q((resolve, reject) => {
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        var storeId = StoreService.getSelectedStore()
          ? StoreService.getSelectedStore().id
          : StoreService.getSavedStoreList()[0].id;
        NewBackendService.invokeWebApiGet(
          `${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/${storeId}/products/list`,
          {}
        ).then((getProductsResponse) => {
          if (getProductsResponse.status === 204) {
            resolve([]);
          } else {
            const products = getProductsResponse.data;
            resolve({
              products: _.map(products, parsers.be.productParser),
              pagination: getProductsResponse.data.page,
            });
          }
        }, reject);
      }),

    getProductVariants: product => {
      var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );

      return NewBackendService.invokeWebApiGet(
          `${endPoints.ecommerceUrl}/businesses/${
            merchantProfile.business.id
          }/${StoreService.getSelectedStore().id}/products/${product.id}/variants`);
    },
    createVariantPromise: (productId, req) => {
      const merchantProfile = JSON.parse(
      StorageService.getLocalStorage('userContext')
    );
      return NewBackendService.invokeWebApiPost(
      `${endPoints.ecommerceUrl}/businesses/${
        merchantProfile.business.id
      }/${StoreService.getSelectedStore().id}/products/${productId}/variants`,
      req
      );
    },
    createVariant: (productId, req) => {
      var merchantProfile = JSON.parse(
        StorageService.getLocalStorage('userContext')
      );
      NewBackendService.invokeWebApiPost(
        `${endPoints.ecommerceUrl}/businesses/${
          merchantProfile.business.id
        }/${StoreService.getSelectedStore().id}/products/${productId}/variants`,
        req
      );
    },
    deleteVariant: (productId, variantId) => {
      var merchantProfile = JSON.parse(
        StorageService.getLocalStorage('userContext')
      );

      NewBackendService.invokeWebApiDelete(
        `${endPoints.ecommerceUrl}/businesses/${
          merchantProfile.business.id
        }/${StoreService.getSelectedStore().id}/products/${productId}/variants/${variantId}`
      );
    },
    patchVariant: (productId, variantId, req) => {
      var merchantProfile = JSON.parse(
        StorageService.getLocalStorage('userContext')
      );

      return NewBackendService.invokeWebApiPatch(
        `${endPoints.ecommerceUrl}/businesses/${
          merchantProfile.business.id
        }/${StoreService.getSelectedStore().id}/products/${productId}/variants/${variantId}`, req
      );
    },
    createProduct: (product, menuIds = []) =>
      $q((resolve, reject) => {
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        product.price = product.price.replace(",", "."); // eslint-disable-line
        const variants =
          product.variants && product.variants.length > 0
            ? product.variants.filter((v) => v.name && v.availability)
            : [];
        const parsedProduct = parsers.app.createProductParser(product, menuIds);
        NewBackendService.invokeWebApiPost(
          `${endPoints.ecommerceUrl}/businesses/${
            merchantProfile.business.id
          }/${StoreService.getSelectedStore().id}/products`,
          parsedProduct
        ).then((response) => {
          const productId = response.data.id;
          if (variants.length) {
            const promises = [];
            variants.forEach((variant) => {
              const req = parsers.app.createProductParser(product, menuIds, variant);
              console.log('creating variant...', variant);
              console.log('req', req);
              promises.push(() => service.createVariantPromise(productId, req));
            });


            executeSubsequentially(promises);
            resolve();
          } else {
            resolve();
          }
        }, reject);
      }),


    editVariants: (product, originalDataVariants) => {
      $q((resolve) => {
        if (!originalDataVariants) {
          resolve();
          return;
        }
        const oldData = originalDataVariants.map(p => { return { id: p.id, name: p.name, availability: p.availability }; });
        const newData = product.variants.map(p => { return { id: p.id, name: p.name, availability: p.availability }; });
        const noChanges = JSON.stringify(oldData) === JSON.stringify(newData);
        if (noChanges) {
          console.log("variants didn't change");
          resolve();
          return;
        } else {
          console.log('variants changed');

            // comparing existing variants with new data
          originalDataVariants.forEach(oldData => {
            const newData = product.variants.filter(p => p.id === oldData.id)[0];

            if (newData) {
                // let's check if anything changed on this variant

              if (newData.name !== oldData.name || newData.availability !== oldData.availability) {
                  // const req = parsers.app.createProductParser(product, menuIds, variant);
                const parsedVariant = parsers.app.variantParser(newData);
                service.patchVariant(product.id, newData.id, parsedVariant);
              }

            } else {
                // if variant was not found then it has been deleted
              service.deleteVariant(product.id, oldData.id);
            }
          });

            // now let's check if there are new variants to create
          const newElements = product.variants.map(n => n.id).filter(n => !originalDataVariants.map(o => o.id).includes(n));
          const promises = [];
          newElements.forEach(newElementId => {
            const newVariant = product.variants.filter(v => v.id === newElementId)[0];
            const req = parsers.app.createProductParser(product, null, newVariant);
            console.log('creating new variant...', newVariant);
            console.log('req', req);
            promises.push(() => service.createVariantPromise(product.id, req));
          });
          executeSubsequentially(promises);
          resolve();
          return;
        }
      });
    },
    editProduct: (product) =>
      $q((resolve, reject) => {
        // FIXME: migliorare la direttiva is-price
        product.price = product.price.replace(",", "."); // eslint-disable-line
        const parsedProduct = parsers.app.productParser(product);
        if (product.img)
          parsedProduct.push({
            op: 'replace',
            path: '/thumb',
            value: product.img,
          });
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        NewBackendService.invokeWebApiPatch(
          `${endPoints.ecommerceUrl}/businesses/${
            merchantProfile.business.id
          }/${StoreService.getSelectedStore().id}/products/${product.id}`,
          parsedProduct
        ).then(() => resolve(product), reject);
        // StentleBackendService.put(`products/${product.id}`, parsedProduct).then(() => resolve(product), reject);
      }),
    deleteProduct: (productId, businessId) =>
      NewBackendService.invokeWebApiDelete(
        `${endPoints.ecommerceUrl}/businesses/${businessId}/${
          StoreService.getSelectedStore().id
        }/products/${productId}`
      ),
    hideProduct: (productId) => setProductAvailability(productId, false),
    showProduct: (productId) => setProductAvailability(productId, true),
    // MENUS
    getMenus: () =>
      $q((resolve, reject) => {
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        NewBackendService.invokeWebApiGet(
          `${endPoints.ecommerceUrl}/businesses/${
            merchantProfile.business.id
          }/${StoreService.getSelectedStore().id}/menus`
        ).then((getCollectionsResponse) => {
          if (getCollectionsResponse.status === 204) {
            resolve([]);
          } else {
            resolve(
              getCollectionsResponse.data._embedded
                ? _.map(
                    getCollectionsResponse.data._embedded.menus,
                    parsers.be.collectionParser
                  )
                : []
            );
          }
        }, reject);
      }),
    createMenu: (menu, businessId) =>
      $q((resolve, reject) => {
        NewBackendService.invokeWebApiPost(
          `${endPoints.ecommerceUrl}/businesses/${businessId}/${
            StoreService.getSelectedStore().id
          }/menus`,
          parsers.app.collectionParser(menu)
        ).then(() => resolve(), reject);
      }),
    editMenu: (menu, menuId, businessId) =>
      $q((resolve, reject) => {
        NewBackendService.invokeWebApiPatch(
          `${endPoints.ecommerceUrl}/businesses/${businessId}/${
            StoreService.getSelectedStore().id
          }/menus/${menuId}`,
          parsers.app.enableDisableCollectionParser(
            menuId,
            undefined,
            menu.name,
            menu.description
          )
        ).then(resolve(), reject);
      }),
    enableMenu: (menuId) =>
      NewBackendService.invokeWebApiPost(
        'merchant/updateStoreMenu',
        parsers.app.enableDisableCollectionParser(menuId, true)
      ),
    disableMenu: (menuId) =>
      NewBackendService.invokeWebApiPost(
        'merchant/updateStoreMenu',
        parsers.app.enableDisableCollectionParser(menuId, false)
      ),
    deleteMenu: (menuId, businessId) =>
      NewBackendService.invokeWebApiDelete(
        `${endPoints.ecommerceUrl}/businesses/${businessId}/${
          StoreService.getSelectedStore().id
        }/menus/${menuId}`
      ),
    setMenuProducts: (menuId, products) =>
      $q((resolve, reject) => {
        var productsIds = products.map((product) => product.id);
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        NewBackendService.invokeWebApiPatch(
          `${endPoints.ecommerceUrl}/businesses/${
            merchantProfile.business.id
          }/${StoreService.getSelectedStore().id}/menus/${menuId}`,
          parsers.app.productIdsCollectionParser(productsIds)
        ).then(resolve(), reject);
      }),

    removeProductFromMenu: (menuId, productIds) =>
      $q((resolve, reject) => {
        var values = [];
        if (productIds instanceof Array) {
          values.push(...productIds);
        } else {
          values.push(productIds);
        }
        var merchantProfile = JSON.parse(
          StorageService.getLocalStorage('userContext')
        );
        NewBackendService.invokeWebApiPatch(
          `${endPoints.ecommerceUrl}/businesses/${
            merchantProfile.business.id
          }/${StoreService.getSelectedStore().id}/menus/${menuId}`,
          parsers.app.productIdsRemoveCollectionParser(values)
        ).then(resolve(), reject);
      }),
  };

  return service;
};

export default catalogServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/catalog.factory.js
 **/